import AuthHelper from '../helpers/AuthHelper'
import store from './../../store'

export const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}

export const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
        return
    } else {
        AuthHelper.checkAuthForAction(store)
    }
    next('/signin')
}


